import { Component } from 'react'
import { error } from 'utils/index'

interface ErrorBoundaryState {
  error?: Error
}

class ErrorBoundary extends Component<{}, ErrorBoundaryState> {
  constructor(props) {
    super(props)
    this.state = { error: null }
  }

  componentDidCatch(e, errorInfo) {
    this.setState({ error: e })

    error(e, errorInfo)
  }

  render() {
    if (this.state.error) {
      return null
    } else {
      return this.props.children;
    }
  }
}

export default ErrorBoundary
